/**
 * Answer-bag keys used by the Clerk auth flow.
 *
 * Extracted into a standalone module so non-Clerk code (e.g. the handoff
 * redirect hook) can reference the keys without pulling in the
 * `@clerk/clerk-react` dependency tree.
 */

export const CLERK_SIGNIN_TOKEN_ANSWER_KEY = "__clerk_signin_token";
export const CLERK_EXTERNAL_SIGNIN_URL_KEY = "__clerk_external_signin_url";
